$(() => {

  //グローバルメニュー開閉時背景
  var globalHeaderOpenBack = function(){
    $('html.js').addClass('js-drawer-open');
    $('body.template-index').addClass('js-drawer-open');
  }
  var globalHeaderCloseBack = function(){
    $('html.js').removeClass('js-drawer-open');
    $('body.template-index').removeClass('js-drawer-open');
  }

  //SPグローバルメニュー開閉
  var spGlobalMenuOpen = function(){
    $('.site-nav--item > a').off();
    $('.site-nav--item > a').on('click', function(e){
      e.preventDefault();
      if($(this).siblings('.sp-nav-header').hasClass('js-sp-menudown')){
        $(this).parent('.site-nav--item').removeClass('js-choice');
        $(this).siblings('.sp-nav-header').removeClass('js-sp-menudown');
        globalHeaderCloseBack();
      } else {
        $(this).parent('.site-nav--item').addClass('js-choice').siblings('.site-nav--item').removeClass('js-choice');
        $(this).siblings('.sp-nav-header').addClass('js-sp-menudown').parents('.site-nav--item').siblings().children('.sp-nav-header').removeClass('js-sp-menudown');
        globalHeaderOpenBack();
      }

    });

    $('.js-side-menubtn').off();
    $('.js-side-menubtn').on('click', function(){
      if($(this).siblings('.sp-nav-header--hide-menu').hasClass('js-close')){
        $(this).siblings('.sp-nav-header--hide-menu').removeClass('js-close').addClass('js-open');
        $(this).parents('.mobile-nav').addClass('js-mobile-nav-hide');
        var announceBarHeight = $('.announcement-bar').length ? $('.announcement-bar').outerHeight() : 0;
        $('#AccessibleNavDrawer').css('--announce-bar-height', announceBarHeight + 'px');
      } else {
        $(this).siblings('.sp-nav-header--hide-menu').removeClass('js-open').addClass('js-close');
        $(this).parents('.mobile-nav').removeClass('js-mobile-nav-hide');
      }

      $('.mobile-nav-wrapper').css('height', '0');
    });

    $('.mobile-nav__sublist-link').on('click', function(){
      // spGlobalMenuReset();
    });

    $('.js-menu-back').on('click', function(){
      $(this).parents('.sp-nav-header--hide-menu').removeClass('js-open').addClass('js-close');
      $(this).parents('.mobile-nav').removeClass('js-mobile-nav-hide');
    });
    $('.js-sub-menu-back').on('click', function(){
      $(this).parents('.sp-nav-header--hide-menu').removeClass('js-open').addClass('js-close');
      $(this).parents('.mobile-nav__dropdown[data-level="2"]').addClass('js-open');
    });

    $('#drawer-menu-toggle').on('change', function() {
      var announceBarHeight = $('.announcement-bar').length ? $('.announcement-bar').outerHeight() : 0;
      $('#AccessibleNavDrawer').css('--announce-bar-height', announceBarHeight + 'px');
    });
  }

  //SPグローバルメニュー開閉リセット
  var spGlobalMenuReset = function(){
    $('.site-nav--item').each(function(){
      $(this).removeClass('js-choice');
    });
    $('.sp-nav-header').each(function(){
      $(this).removeClass('js-sp-menudown');
    });
    $('.mobile-nav').each(function(){
      $(this).removeClass('js-mobile-nav-hide');
    });
    $('.sp-nav-header--hide-menu').each(function(){
      $(this).removeClass('js-open').addClass('js-close');
    });
    globalHeaderCloseBack();
  }

  //PCグローバルメニュー開閉
  var pcGlobalMenuOpen = function(){
    $('.site-nav--item').hover(function(){
      $(this).find('.site-nav--item--mega-menu').addClass('js-mega-menu-open');
      $(this).children('a').addClass('js-hover');
      globalHeaderOpenBack();
      setTimeout(() => {
        $(this).find('.site-nav--item--mega-menu.js-mega-menu-open').css('z-index', '1');
      }, 500);
    },function(){
      $(this).find('.site-nav--item--mega-menu.js-mega-menu-open').css('z-index', '-1');
      $(this).find('.site-nav--item--mega-menu').removeClass('js-mega-menu-open');
      $(this).children('a').removeClass('js-hover');
      globalHeaderCloseBack();
    });
  }

  //PCグローバルメニュー開閉リセット
  var pcGlobalMenuReset = function(){
    $('.site-nav__link').each(function(){
      $(this).removeClass('js-hover');
    });
    globalHeaderCloseBack();
  }

  //メディアクエリ
  var mediaQuery = matchMedia('(max-width: 749px)');
  function handle(mq){
    if(mq.matches){

      //iosブラウザバック対策
      window.onpageshow = function(event){
        if(event.persisted){
          window.location.reload();
        }
      };

      pcGlobalMenuReset();
      spGlobalMenuOpen();

      $('.footer-story--menu-btn').off();
      $('.footer-story--menu-btn').on('click', function(){
        if($(this).hasClass('js-footer-open')){
          $(this).removeClass('js-footer-open').next().stop().slideUp();
        } else {
          $(this).addClass('js-footer-open').next().stop().slideDown();
        }
      });
      
      $('.top-slider--list').not('.slick-initialized').slick({
        autoplay: true,
        arrows: false,
        dots: true,
        dotsClass: 'top-slider--dots',
        speed: 1000
      });

      //アイコン調整
      if($('.help-page--close--btn').next().css('display') === 'none'){
        $('.help-page--close--btn').removeClass('js-close-open');
      }

    } else {
      spGlobalMenuReset();
      pcGlobalMenuOpen();
      $('.top-slider--list.slick-initialized').slick('unslick');
    }

  }
  mediaQuery.addListener(handle);
  handle(mediaQuery);

  //画像切り替え
  var $elem = $('.js-image-switch');
  var sp = '_sp.';
  var pc = '_pc.';
  var replaceWidth = 750;

  function imageSwitch() {
    var windowWidth = parseInt(window.innerWidth);
    $elem.each(function() {
      var $this = $(this);
      if(windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
      }
    });
  }
  imageSwitch();

  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      imageSwitch();
    }, 200);
  });
  
  //ヘルプページタブ切り替え
  var tabTarget;
  var unitTarget;
  var cmTarget = $('[data-unit="cm"]');
  var inchesTarget = $('[data-unit="inches"]');
  var internationalTarget = $('[data-unit="international"]');

  $('.help-page--tab-link').off();
  $('.help-page--tab-link').on('click', function(event){
    event.preventDefault();
    $(this).addClass('js-tab-select').siblings().removeClass('js-tab-select');
    tabTarget = $(this).attr('href');
    $(tabTarget).addClass('js-tab-select').siblings().removeClass('js-tab-select');
    
  });

  $('.help-page--unit-change').off();
  $('.help-page--unit-change').on('click', function(event){
    event.preventDefault();
    unitTarget = $(this).attr('data-unit');

    if(unitTarget === 'cm'){
      $(this).closest('.help-page--unit-block').find('[data-unit="cm"]').addClass('js-unit-select');
      $(this).closest('.help-page--unit-block').find('[data-unit="inches"]').removeClass('js-unit-select');
      $(this).closest('.help-page--unit-block').find('[data-unit="international"]').removeClass('js-unit-select');
    }
    
    if(unitTarget === 'inches'){
      $(this).closest('.help-page--unit-block').find('[data-unit="cm"]').removeClass('js-unit-select');
      $(this).closest('.help-page--unit-block').find('[data-unit="inches"]').addClass('js-unit-select');
      $(this).closest('.help-page--unit-block').find('[data-unit="international"]').removeClass('js-unit-select');
    }
    
    if(unitTarget === 'international'){
      $(this).closest('.help-page--unit-block').find('[data-unit="cm"]').removeClass('js-unit-select');
      $(this).closest('.help-page--unit-block').find('[data-unit="inches"]').removeClass('js-unit-select');
      $(this).closest('.help-page--unit-block').find('[data-unit="international"]').addClass('js-unit-select');
    }

  });

  //helpページアコーディオン
  $('.help-page--slide--btn').off();
  $('.help-page--slide--btn').on('click', function(){
    if($(this).hasClass('js-answer-open')){
      $(this).removeClass('js-answer-open').next().slideUp(100, 'swing');
    } else {
      $(this).addClass('js-answer-open').next().slideDown(100, 'swing');
    }
  });
  
  $('.help-page--close--btn').on('click', function(){
    if($(this).next().not(':animated').length >= 1){
      $(this).next().slideToggle();
      if($(this).hasClass('js-close-open')){
        $(this).removeClass('js-close-open');
      } else {
        $(this).addClass('js-close-open');
      }
    }
  });

  //ヘッダーメニューアコーディオン
  $('.drawer-menu--slide--btn').off();
  $('.drawer-menu--slide--btn').on('click', function(){
    if($(this).hasClass('js-answer-open')){
      $(this).removeClass('js-answer-open').next().slideUp(100, 'swing');
    } else {
      $(this).addClass('js-answer-open').next().slideDown(100, 'swing');
    }
  });
  
  $('.help-page--close--btn').on('click', function(){
    if($(this).next().not(':animated').length >= 1){
      $(this).next().slideToggle();
      if($(this).hasClass('js-close-open')){
        $(this).removeClass('js-close-open');
      } else {
        $(this).addClass('js-close-open');
      }
    }
  });

  //ヘルプページ FitGuide
  window.addEventListener('load', function() {
    const galleryElements = document.querySelectorAll('[data-fit-guide-gallery]');

    if(galleryElements.length > 0) {
      galleryElements.forEach(function(galleryElement) {
        let flickityInstance = null;

        function toggleFlickity() {
          
          if(location.href.indexOf('products') > -1) {
            if(flickityInstance) {
              flickityInstance.destroy();
            }
            flickityInstance = new Flickity(galleryElement, {
              cellAlign:'left',
              prevNextButtons:false,
              pageDots: true,
            });
          } else if (window.innerWidth >= 750 && flickityInstance) {
            flickityInstance.destroy();
          } else if(window.innerWidth < 750 ) {
            if(flickityInstance) {
              flickityInstance.destroy();
            }
            flickityInstance = new Flickity(galleryElement, {
              cellAlign:'left',
              prevNextButtons:false,
              pageDots: true,
            });
          }
        }
    
        // Initial check
        toggleFlickity();
    
        // Add click handler for tab links
        document.querySelector('a[href="#fit-guide"]').addEventListener('click', function() {
          setTimeout(toggleFlickity, 200);
        });
    
        // Add event listener for window resize
        window.addEventListener('resize', toggleFlickity);
      });

    }
  });

  const videoControllerList = document.querySelectorAll('.help-page--fit-guide--video-controller');
  if(videoControllerList.length > 0) {
    videoControllerList.forEach(function(videoController) {
      videoController.addEventListener('click', function() {
        const videoId = videoController.getAttribute('data-video');
        const video = document.getElementById(videoId);
        if (video.paused) {
          video.play();
          videoController.querySelector('.icon-video-play').style.display = 'block';
          videoController.querySelector('.icon-video-pause').style.display = 'none';
        } else {
          video.pause();
          videoController.querySelector('.icon-video-play').style.display = 'none';
          videoController.querySelector('.icon-video-pause').style.display = 'block';
        }
      });
    });
  }

  // 2024.7.6 Delete
  // //PC版ヘッダーメニュー　ストーリーコンテンツ一部非表示
  // $('.site-nav--item--mega-menu--box--hierarchy-one')[0].remove();
  // //SP版フッター　ニュースメニュー非表示
  // // $('.footer-story--menu-btn')[1].remove();
  // // $('.footer-story--menu-list')[1].remove();
  
  //ipad対策
  var uaCheck = window.navigator.userAgent.toLowerCase();
  if(uaCheck.indexOf('ipad') != -1 || uaCheck.indexOf('macintosh') != -1 && 'ontouchend' in document){
    $('.site-nav--item a.site-nav__link').on('click', function(e){
      e.preventDefault();
    });
  }

});


// 2024.10.9 Add : limit 3 items in cart
const checkItemQuantity = () => {
  const cartCheckoutBtnList = document.querySelectorAll('[name="checkout"]'),
    checkoutLoginBtnList = document.querySelectorAll('a.cart__submit'),
    cartAlertArea = document.querySelector('#alert-message-area');

    if(cartCheckoutBtnList.length > 0){
      cartCheckoutBtnList.forEach(function(cartCheckoutBtn){
        cartCheckoutBtn.classList.remove("is-disabled");
      });
    }
    if(checkoutLoginBtnList.length > 0){
      checkoutLoginBtnList.forEach(function(checkoutLoginBtn){
        checkoutLoginBtn.classList.remove("is-disabled");
      });
    }
    cartAlertArea.innerHTML = "";

  if (cartCheckoutBtnList.length > 0 || checkoutLoginBtnList.length > 0) {
    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          const itemSumQuantity = cart.items
            .filter((cartItem) => cartItem.variant_id === item.variant_id)
            .reduce((acc, item) => acc + item.quantity, 0);

          if (itemSumQuantity > 3) {
            if(cartCheckoutBtnList.length > 0){
              cartCheckoutBtnList.forEach(function(cartCheckoutBtn){
                cartCheckoutBtn.classList.add("is-disabled");
              });
            }
            if(checkoutLoginBtnList.length > 0){
              checkoutLoginBtnList.forEach(function(checkoutLoginBtn){
                checkoutLoginBtn.classList.add("is-disabled");
              });
            }
            cartAlertArea.innerHTML = `${item.title}は3点までしか購入できません。`;
            alert( `${item.title}は3点までしか購入できません。`);
            break;
          }
        }

      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

// 2025.1.7 Add : Reset prev collection information
if(localStorage.hasOwnProperty('prev_collection') && location.pathname.indexOf('/products') === -1){
  localStorage.removeItem("prev_collection");
}

// 2025.3.15 Add : Login form redirect
document.addEventListener('DOMContentLoaded', (event) => {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const param_redirect = params.get("redirect");
  const form = location.pathname === "/account/register" ? document.querySelectorAll('#create_customer, form[action="/account"][method="post"]')[0] : document.querySelectorAll('#customer_login, form[action="/account/login"][method="post"]')[0];
  if(form && param_redirect && (
    param_redirect.indexOf( 'cart' ) > -1
  )){ 
    const $redirect = document.createElement('input');

    $redirect.setAttribute('name', 'return_to');
    $redirect.setAttribute('type', 'hidden');
    $redirect.value = param_redirect;
    form.appendChild($redirect);
  }
});